import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { FileUploadResult } from '@dot-it/jml-lib'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { FileUploadDownloadService } from '../../services/file-upload-download.service'

@Component({
  selector: 'jml-lib-license-upload-dialog',
  templateUrl: './license-upload-dialog.component.html',
  styleUrls: ['./license-upload-dialog.component.scss']
})
export class LicenseUploadDialogComponent implements OnInit {
  uploadUrl: string

  chooseLabel = 'Datei auswählen'
  uploadLabel = 'Hochladen'
  cancelLabel = 'Abbrechen'

  constructor(
    private fileService: FileUploadDownloadService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false
    this.uploadUrl = this.fileService.getLicenseUploadUrl()
  }

  //Standard Events of primeNG component

  onBeforeUpload(event: any) {
    const data: FormData = event.formData
  }

  onUpload(event: any) {
    const uploadResult = <FileUploadResult>event.originalEvent.body
    this.ref.close(uploadResult)
  }

  onError(event: any) {
    this.ref.close()
  }

  onClear(event: any) {}

  onRemove(event: any) {}

  onSelect(event: any) {}
}
